var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"100%","height":"100%"}},[_c('video',{staticClass:"video-play",attrs:{"id":_vm.videoPlayer.videoId,"autoplay":""},domProps:{"muted":_vm.isMuted}}),_c('canvas',{staticStyle:{"display":"none"},attrs:{"id":_vm.videoPlayer.canvasId,"width":"515","height":"300"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }